











/** @format */

import { Vue, Component, Watch, Mixins } from 'vue-property-decorator';
import { AREA_LIST } from '../router-names';
import { dictAlonePayMap } from '@/types/parking-lot-management/dictionaries';
import { addOrEditArea, queryArea } from '@/api/parking-lot-management/index';
import AddEditArea from './components/add-edit-area.vue';
import { Mutation } from 'vuex-class';
import { CLOSE_CURRENT_TAB } from '@/store/mutation-types';
import GoBackWithCloseTab from '@root/common/mixins/go-back-with-close-tab';

@Component({
  components: { AddEditArea }
})
export default class AreaListEdit extends Mixins(GoBackWithCloseTab) {
  goBackRouteName = AREA_LIST; // 返回前一页的路由name

  path = '/smart-parking/parking-lot-management/area-list/';
  @Mutation(`pageTabs/${CLOSE_CURRENT_TAB}`)
  closeCurrentTab!: Function;

  headTitle = '区域编辑'; // 标题
  areaId = '';
  formData = null; // 表单数据
  // formData = {
  //   areaName: '', //区域名称
  //   parkId: '', // 车场id
  //   parkName: '', //车场名称
  //   areaId: '', //区域id
  //   operationType: '', //运营类型  01：开发商委托 02：业委会委托 03：小业主委托 04：自有停车场
  //   typeIn: '', //车位录入方式  01：手动录入 02：根据车位资源自动计算
  //   propertyNum: '', //产权车位数量
  //   monthNum: '', //月卡车位数量
  //   tempNum: '', //临停车位数量
  //   isZeroAllowedEnter: '', //满位是否允许进入 00：不允许 01：允许
  //   alonePay: '', //是否需要独立计费  00:不需要  01:需要
  //   unauthorizedEnter: '', //非授权类型车辆是否禁入 00：是 01：否
  // }

  // 面包屑数据
  get breadcrumbNav() {
    return [
      {
        label: '区域信息',
        location: {
          name: AREA_LIST
        }
      },
      {
        label: this.headTitle
      }
    ];
  }
  // 生命周期初始化
  activated() {
    this.areaId = this.$route.params.areaId;
    this.initShow();
  }
  // 请求列表数据
  async initShow() {
    try {
      const { status, code, msg, data } = await queryArea({ areaId: this.areaId });
      this.formData = { ...data, areaId: this.areaId };
    } catch (e) {
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    }
  }
  // 点击保存
  isSubmitOk() {
    this.goBack();
  }
}
